// ESTILOS
import styles from '../../estilos/inicioRegistro.module.css';
// PAQUETES
import React, {useState} from "react";
import axios from "axios";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import Swal from 'sweetalert2';
// COMPONENTES
import FooterInicioRegistro from '../../partials/footerInicioRegistro';
import SincronizarGoogle from './sincronizarGoogle';
import ZonaCargando from '../alertas/zonaCargando';
import HelmetSEO from '../../componentesEspeciales/helmetSEO';
import { eventoLoginAttempt, eventoLoginSuccess, eventoLoginFailed } from '../../funcionesDatos/eventoPropio';


function InicioSesion() {

    const navigate = useNavigate();
    const location = useLocation();
    const { returnTo, returnState } = location.state || {}; // páginas a las que se debe volver en dado caso, como reserva o otroas.
    const { usuario, cargandoUsuario, setUsuario } = useOutletContext() || {}; // variables de context

    const[input, setInput]        = useState ({  usuarioInicio: "", contraseña: "" });
    const [cargando, setCargando] = useState(false);

    function handleChange(event){
        const {name, value} = event.target;
        // guardar el valor previo.
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        });
    }

    function handleClick(event){
        // evita el parpadeo predefinido
        event.preventDefault();
        setCargando(true);

        // crear objeto para pasar a servidor
        const nUsuario = {
            username: input.usuarioInicio,
            password: input.contraseña
        }

        eventoLoginAttempt({ metodo: "email" });

        // pasar datos a servidor o bd.
        axios.post("/iniciar-sesion", nUsuario, {withCredentials: "true"})
        .then(async function (response) {
            setCargando(false);
            // error de inicio de sesión
            if(response.data.autenticado === false ){
                eventoLoginFailed({ metodo: "email", razon: response.data.razon || "NA" });
                Swal.fire({ icon: 'error', title: "Error", text: response.data.mensaje, customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' }, });
            }
            // usuario autenticado
            else{
                console.log("data: ", response.data.usuario);
                const usuarioLogueado = response.data.usuario;
                eventoLoginSuccess({ metodo: "email", usuarioId: usuarioLogueado.idUsuario });

                // Staff (Administrador, SuperAdmin, Soporte, Moderador, Contador) va directo al panel admin.
                // Nota: "Comprador"/"Vendedor" NO son valores de `tipo` (eso vive en `modo`), por eso se
                // comparan por separado más abajo.
                const rolesStaff = ["Administrador", "SuperAdmin", "Soporte", "Moderador", "Contador"];
                if (rolesStaff.includes(usuarioLogueado.tipo)) {
                    if (typeof setUsuario === 'function') setUsuario(usuarioLogueado);
                    return navigate("/admin/");
                }

                // ✅ Si venía de una página interrumpida (ej. reservar un servicio sin sesión),
                // siempre lo devolvemos ahí. returnTo SIEMPRE apunta a una página de comprador
                // (ver servicio, reserva, pago) — si el usuario quedó en modo Vendedor,
                // RutaZonaGlobalComprador lo rebotaría a /vendedor apenas navegamos, así que
                // forzamos el modo a Comprador primero para que sí pueda entrar.
                if (returnTo) {
                    if (usuarioLogueado.modo === "Vendedor") {
                        try {
                            const resModo = await axios.post("/cambiar-modo", {
                                params: { usuario: usuarioLogueado.username, modoActual: "Vendedor" }
                            }, { withCredentials: true });
                            usuarioLogueado.modo = resModo?.data?.nuevoModo || "Comprador";
                        } catch (err) {
                            console.log("Error forzando modo Comprador tras iniciar sesión:", err);
                            usuarioLogueado.modo = "Comprador"; // seguimos igual, no bloqueamos el login por esto
                        }
                    }

                    if (typeof setUsuario === 'function') setUsuario(usuarioLogueado);
                    return navigate(returnTo, { state: returnState });
                }

                // ✅ Actualizar usuario global (evita loop al volver a /reserva)
                if (typeof setUsuario === 'function') setUsuario(usuarioLogueado);

                // Sin returnTo: por defecto según su modo actual.
                if (usuarioLogueado.modo === "Vendedor") { return navigate("/vendedor"); }

                return navigate("/");
            }
        })
        .catch(function(err){
            setCargando(false);
            eventoLoginFailed({ metodo: "email", razon: "error_red_o_servidor" });
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error iniciando sesión. Vuelve a intentar",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
            });
            console.log('error iniciar-sesion: ', err);
        });
    }



    // registrar, pero en dado caso, volver a la pagina anterior
    async function registrar(e) {
        e.preventDefault();
        return navigate("/registrar", {
            state: {
                returnTo,
                returnState,
            }
        });
    }

    return(
    <>

        {/*
            SEO dinámico de inicio de sesión.
            Cambia automáticamente:
            - título
            - descripción SEO
            - Open Graph
            para buscadores y redes sociales.
        */}
        <HelmetSEO
            titulo="Iniciar sesión | Zervicy"
            descripcion="Accede a tu cuenta de Zervicy para reservar servicios, gestionar compras o administrar tus servicios publicados."
        />
    <div className={styles.containerUsuario}>
        { (cargando) ? <ZonaCargando />
        : <main className={styles['form-signin']}>
            <form>
            {/* Imagen y título */}
            <div className='d-flex justify-content-center'>
            <a href='/'>
                <img className="my-5" src="/imagenes/marca/zervicyblancohorizontal.png" alt="" height="80" />
                </a>
            </div>
            <h3 className="h3 mb-3 fw-normal text-light text-center">Iniciar sesión</h3>

            {/* usuario */}
            <div className="form-floating">
                <input onChange={handleChange} value={input.usuarioInicio} name="usuarioInicio" type="text" className="form-control"  placeholder="miusuario123" />
                <label htmlFor="floatingInput">Usuario</label>
            </div>


            {/* Contraseña  */}
            <div className="form-floating">
                <input onChange={handleChange} value={input.contraseña} name="contraseña" type="password" className="form-control" id="floatingPassword" placeholder="Password" />
                <label htmlFor="floatingPassword">contraseña</label>
            </div>

            {/* Botón enviar */}
            <button onClick={handleClick} className="btn btn-primary w-100 py-2" type="submit">
                <i className="bi bi-box-arrow-in-right me-2" />
                Iniciar Sesión
            </button>

            {/* Línea divisora con "o" en el centro */}
            <div className="d-flex align-items-center my-1 w-100">
                <hr className="flex-grow-1 border-white" />
                <span className="mx-2 text-white">o</span>
                <hr className="flex-grow-1 border-white" />
            </div>


            {/* Botón de inicio de sesión */}
            <SincronizarGoogle usuario={"desdeInicio"} returnTo={returnTo} />

            <div className="my-3 w-100">
                <hr className="border-white" />
            </div>

            <p className="text-center text-light mb-2" >
                ¿Aún no tienes cuenta?
            </p>

            <button onClick={registrar} className="btn btn-secondary w-100 py-2" type="button">
                <i className="bi bi-person-plus me-2" />
                Registrar
            </button>



            {/* footer */}
            <FooterInicioRegistro />
            </form>
        </main>
        }
    </div>
    </>
    )
}



export default InicioSesion;
